// 包一层 /api/v1/bootstrap/* 的调用。匿名访问（§14.1），因此无需
// 依赖 sessionStore 的 csrf 或 cookie —— 但用同一个 http() 实例可以
// 在登录态也复用（例如 admin 也可能手动触发 finalize）。
import { http } from '../runtime/http';

export interface Ipv4Snapshot {
  address: string | null;
  prefix: number | null;
  gateway: string | null;
  dns: string[];
}

export interface OnlineInterface {
  name: string;
  type: 'ethernet' | 'wifi' | 'other';
  carrier: boolean;
  ipv4: Ipv4Snapshot | null;
  is_primary: boolean;
}

export type FinalizeStage =
  | 'idle'
  | 'applying_network'
  | 'syncing_casdoor'
  | 'writing_discovery'
  | 'marking_completed'
  | 'done'
  | 'error';

export interface BootstrapStateBody {
  completed: boolean;
  completed_at: string | null;
  finalize_stage: FinalizeStage;
  finalize_error: string | null;
  primary_interface: string | null;
  access_url: string | null;
  online_interfaces: OnlineInterface[];
}

export interface NetworkIpv4Payload {
  address: string;
  prefix: number;
  gateway: string;
  dns: string[];
}

export type BootstrapNetworkPayload =
  | { mode: 'dhcp'; interface: string }
  | { mode: 'static'; interface: string; ipv4: NetworkIpv4Payload }
  | { mode: 'skip' };

export interface BootstrapFinalizeBody {
  completed: boolean;
  finalize_stage: FinalizeStage;
  finalize_error: string | null;
  access_url: string | null;
  primary_interface: string | null;
}

export async function readBootstrapState(): Promise<BootstrapStateBody> {
  const { data } = await http().get<BootstrapStateBody>('/bootstrap/state');
  return data;
}

export async function submitBootstrapNetwork(
  payload: BootstrapNetworkPayload,
): Promise<void> {
  await http().post('/bootstrap/network', payload);
}

export async function runBootstrapFinalize(): Promise<BootstrapFinalizeBody> {
  const { data } = await http().post<BootstrapFinalizeBody>(
    '/bootstrap/finalize',
  );
  return data;
}

// DEBUG 用：把 bootstrap_state 清空（不动 Casdoor / 用户 / discovery），
// 让守卫把页面送回 /welcome。
export async function resetBootstrapState(): Promise<void> {
  await http().post('/bootstrap/reset');
}
